import type { TextChain } from '@/api/types/stowed-element'
import { nextNumericId } from '@/lib/text-linking/text-chain-mutator'

/**
 * Adds a placed template's text chains to the spread's own, never replacing them.
 *
 * The write that carries chains replaces the spread's whole list, so the list sent has to be the
 * spread's existing chains plus the template's. The template's chain ids are its own and the
 * backend does not renumber them, so they can collide with the spread's chains and with an earlier
 * placement of the same template. Each gets the next unused numeric id instead. Members are left
 * alone: the backend already renumbered their uids above the `uidSeed` it was given, so they name
 * the placed shapes and nothing else on the spread.
 */
export function mergeTemplateTextChains(
  existing: readonly TextChain[],
  templateChains: readonly TextChain[]
): TextChain[] {
  const merged = [...existing]

  for (const chain of templateChains) {
    if (chain.textBox.length < 2) continue

    merged.push({
      ...chain,
      id: nextNumericId(merged),
      textBox: chain.textBox.map((box) => ({ ...box })),
    })
  }

  return merged
}
